import { render, staticRenderFns } from "./FocusableWithoutPagination.vue?vue&type=template&id=e2b2ec8a&"
import script from "./FocusableWithoutPagination.vue?vue&type=script&lang=js&"
export * from "./FocusableWithoutPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports